/* RESPONSIBLE TEAM: team-proactive-support */

import Model, { attr } from '@ember-data/model';

export default class CustomEmailAssetsDomain extends Model {
  @attr('string') assetsDomain;
  @attr('boolean') validRecordExists;
}
